<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <section>
        <fieldset>
          <legend>
            {{ pageVocabs + "legend" | translate }}
          </legend>

          <div class="row"></div>
          <div>
            <button
              class="mat-ripple btn tw-mr-[5px] ltr:tw-ml-[5px] tw-mb-[10px] button-shadow btn-hover-rise btn-success"
              (click)="onAddClass()"
            >
              +
            </button>
          </div>

          <div>
            <div *ngFor="let rule of newClassModel; let i = index">
              <!--fields-->
              <app-smart-sms-number-classes-fields
                [isEdit]="isEdit"
                [classModel]="newClassModel[i]"
                [index]="i"
                (city)="newClassModel[i].city = $event"
                (cityId)="newClassModel[i].cityId = $event"
                (province)="newClassModel[i].province = $event"
                (class)="newClassModel[i].class = $event"
                (removeClass)="onRemoveClass($event)"
                (form)="createClassesForms[i] = $event"
              >
              </app-smart-sms-number-classes-fields>
            </div>
          </div>
        </fieldset>
      </section>
      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="isEdit"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
